import React from 'react'
// import im from './ProImg/im.png'
import r1 from '../ProImg/r1.png'
import r2 from '../ProImg/r2.png'
import r3 from '../ProImg/r3.png'
import r4 from '../ProImg/r4.png'
import r5 from '../ProImg/r5.png'
import r6 from '../ProImg/r6.png'
export default function CardF() {

  return (
    <div>
        <div className='container-fluid'>
          <h1 className='text-center pt-3'>Rooms</h1>
  <div className='row p-0 m-0 px-5 mt-5'>
    <div className='col-sm-4'>
    <div className='card1'>
  <img src={r1} alt='' className='img-fluid' style={{height:'185px'}}/>
  
 </div>
    </div> 
    <div className='col-sm-4'>
    <div className='card1'>
  <img src={r2} alt='' className='img-fluid' />
  
 </div>
    </div>

    <div className='col-sm-4'>
    <div className='card1'>
  <img src={r3} alt='' className='img-fluid'/>
  
 </div>
    </div>
    
  </div>
  
  <div className='row p-0 m-0 px-5 mt-5'>
    <div className='col-sm-4'>
    <div className='card1'>
  <img src={r4} alt='' className='img-fluid'/>
  
 </div>
    </div> 
    <div className='col-sm-4'>
    <div className='card1'>
  <img src={r5} alt='' className='img-fluid'/>
  
 </div>
    </div>

    <div className='col-sm-4'>
    <div className='card1'>
  <img src={r6} alt='' className='img-fluid' style={{height:'185px'}}/>
  
 </div>
    </div>
    
  </div>
</div>
    </div>
  )
}

